import ChannelTextList from './List'

export default {
  list: ChannelTextList
}
